import "./NotFoundPage.css";

export default function NotFoundPage(props) {
  return (
    <div className="not-found-page">
      <div className="fof">
        <h1>Error 404</h1>
      </div>
    </div>
  );
}
